import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=45b9f6ae&scoped=true"
import script from "./orderRefund.vue?vue&type=script&lang=js"
export * from "./orderRefund.vue?vue&type=script&lang=js"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=45b9f6ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9f6ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b9f6ae')) {
      api.createRecord('45b9f6ae', component.options)
    } else {
      api.reload('45b9f6ae', component.options)
    }
    module.hot.accept("./orderRefund.vue?vue&type=template&id=45b9f6ae&scoped=true", function () {
      api.rerender('45b9f6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderRefund.vue"
export default component.exports